module.exports = __webpack_public_path__ + "img/725.82b31127.jpg";